module.exports = __webpack_public_path__ + "static/media/yandex-device-speacker.bd0d150e.png";